import { useContext } from '@nuxtjs/composition-api';
import { DISCOUNT_NAME } from '~/constants';
import { CartType } from '~/enums/cart';
import { useFirstPurchasePromotion } from '../useFirstPurchasePromotion';
import { useStore } from '../useStore';

export const useShipmentFreeMessage = () => {
  const store = useStore();
  const { i18n } = useContext();
  const { hasPurchaseHistory } = useFirstPurchasePromotion();

  /* ProductCartModalBodyに出す送料無料メッセージ、ロゴ表示制御用の支払い方法idsを渡す */
  const setShippingAndPayment = async (cartName: string) => {
    const cart = store.state.modules.cart.carts.find((cart) => cart.cart_name === cartName);
    if (!cart) return;

    const simulation = await store.dispatch('modules/cart/postSimulation', {
      cartId: cart.cart_id,
    });

    let freeShippingText = '';
    const untilShipmentFreeAmount = simulation.shipments[0].until_shipment_free_amount;

    /**
     * 購入履歴なし＋一般商品/ワインセラーの場合、初回送料無料特典の対象
     * それ以外の場合、あとX円で送料無料/送料無料金額達成（APIレスポンス次第）
     *
     * 送料無料じゃない場合、金額部分の表示スタイルが異なるため、メッセージはstoreに保存しない
     *
     * !!未ログインの場合はシミュレーションAPIが一律送料無料を返すため、ログイン状態＋購入履歴cookieの判定が必要!!
     */
    if (!store.state.auth.authenticated) {
      if (
        !hasPurchaseHistory.value &&
        (cart.cart_name === CartType.GENERAL || cart.cart_name === CartType.WINE_CELLAR)
      ) {
        freeShippingText = i18n.t('Cart-01.modal.firstPurchasePromotion').toString();
      } else if (!untilShipmentFreeAmount) {
        freeShippingText = i18n.t('Item-02.modal.free').toString();
      }
    } else if (simulation.cart_discounts.find((discount) => discount.name === DISCOUNT_NAME.FIRST_TIME)) {
      freeShippingText = i18n.t('Cart-01.modal.firstPurchasePromotion').toString();
    } else if (!untilShipmentFreeAmount) {
      freeShippingText = i18n.t('Item-02.modal.free').toString();
    }

    store.dispatch('modules/cartMessage/setShipmentFreeMessage', {
      freeShippingText,
      shipmentFreeAmount: untilShipmentFreeAmount.toLocaleString(),
      totalAmount: simulation.price_set.total_amount.toLocaleString(),
    });
  };

  return {
    setShippingAndPayment,
  };
};
